(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/match-list.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/match-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.MatchList = Marionette.CollectionView.extend({
    tagName: 'ul',
    className: 'list-group',
    childView: svs.maltipset.views.MatchListItem
  });
})(Backbone, _, svs);


 })(window);